import { Reducer } from "redux";
import { defaultRequestState, paginatedDefaults } from "../constants";
import { getFilters } from "../tournaments/functions";
import { PptInterface } from "./types";
import * as actionTypes from "./actionTypes";
import * as PPTHandlers from "./handlers/getPpt";
import * as filterHandlers from "./handlers/setFilter";
import { defaultPptsFilters } from "./constants";

const INITIAL_STATE: PptInterface = {
  ppt: {
    filter: getFilters(),
    ppt_scrim: {
      game: null,
      data: [],
      filter: { ...defaultPptsFilters },
      ...paginatedDefaults
    },
    ppt_cup: {
      game: null,
      data: [],
      filter: { ...defaultPptsFilters },
      ...paginatedDefaults
    },
    ppt_master: {
      game: null,
      data: [],
      filter: { ...defaultPptsFilters },
      ...paginatedDefaults
    }
  },
  requestStates: {
    ppt_scrim: {
      data: { ...defaultRequestState },
      filter: { ...defaultRequestState },
      paginated: { ...defaultRequestState }
    },
    ppt_cup: {
      data: { ...defaultRequestState },
      filter: { ...defaultRequestState },
      paginated: { ...defaultRequestState }
    },
    ppt_master: {
      data: { ...defaultRequestState },
      filter: { ...defaultRequestState },
      paginated: { ...defaultRequestState }
    }
  }
};

const PPTReducer: Reducer<PptInterface> = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case actionTypes.PPT_GET_PPT_SCRIM_REQUESTED:
      return PPTHandlers.requested(state, "ppt_scrim", action.paginated);
    case actionTypes.PPT_GET_PPT_SCRIM_FAILED:
      return PPTHandlers.failed(state, action, "ppt_scrim", action.paginated);
    case actionTypes.PPT_GET_PPT_SCRIM_SUCCESS:
      return PPTHandlers.success(state, action, "ppt_scrim", action.paginated);
    case actionTypes.PPT_GET_PPT_SCRIM_CLEAR:
      return PPTHandlers.clear(state, "ppt_scrim", action.paginated);
    case actionTypes.PPT_GET_PPT_CUP_REQUESTED:
      return PPTHandlers.requested(state, "ppt_cup", action.paginated);
    case actionTypes.PPT_GET_PPT_CUP_FAILED:
      return PPTHandlers.failed(state, action, "ppt_cup", action.paginated);
    case actionTypes.PPT_GET_PPT_CUP_SUCCESS:
      return PPTHandlers.success(state, action, "ppt_cup", action.paginated);
    case actionTypes.PPT_GET_PPT_CUP_CLEAR:
      return PPTHandlers.clear(state, "ppt_cup", action.paginated);
    case actionTypes.PPT_GET_PPT_MASTER_REQUESTED:
      return PPTHandlers.requested(state, "ppt_master", action.paginated);
    case actionTypes.PPT_GET_PPT_MASTER_FAILED:
      return PPTHandlers.failed(state, action, "ppt_master", action.paginated);
    case actionTypes.PPT_GET_PPT_MASTER_SUCCESS:
      return PPTHandlers.success(state, action, "ppt_master", action.paginated);
    case actionTypes.PPT_GET_PPT_MASTER_CLEAR:
      return PPTHandlers.clear(state, "ppt_master", action.paginated);
    case actionTypes.PPT_FILTER_PPT_REQUESTED:
      return filterHandlers.requested(state, action.payload.key);
    case actionTypes.PPT_FILTER_PPT_FAILED:
      return filterHandlers.failed(state, action, action.payload.key);
    case actionTypes.PPT_FILTER_PPT_SUCCESS:
      return filterHandlers.success(state, action, action.payload.key);
    default:
      return state;
  }
};

export default PPTReducer;
